import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/blocks`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/blocks/${id}`);
  },
  async findAll() {
    return axios.get('/blocks');
  },
  async delete({ id }) {
    return axios.delete(`/blocks/${id}`);
  },
  async update(formData) {
    return axios.put(`/blocks/${formData.id}`, formData);
  },
  async updateActive(formData) {
    return axios.put(`/blocks/${formData.id}/active`);
  },
  async clone(formData) {
    return axios.post(`/blocks/clone`, formData);
  },
};
